import React from 'react';
import classNames from 'classnames';

import { Member } from '@wix/members-domain-ts';

import styles from './following-followers.scss';
import withTranslate from '../../../hoc/with-translate';
import { Button } from '../../button';

interface Props {
  t: TranslationFunction;
  member: Member;
  className?: string;
  goToFFPage: (memberId: string, pageType: boolean) => void;
}

const FollowingFollowersComponent: React.StatelessComponent<Props> = ({ member, goToFFPage, t, className }) => (
  <div className={classNames(className, 'ma-members-ff-font', styles.ffContainer)}>
    <Button onClick={() => goToFFPage(member.uid, true)} className={classNames(styles.btn)} dataHook="mb-followers">
      <span className={styles.ffNumber}>{member.followerCount}</span> <span>{t('profile-widget.followers')}</span>
    </Button>
    <Button onClick={() => goToFFPage(member.uid, false)} className={styles.btn} dataHook="mb-following">
      <span className={styles.ffNumber}>{member.followingCount}</span> <span>{t('profile-widget.following')}</span>
    </Button>
  </div>
);

export const FollowingFollowers = withTranslate(FollowingFollowersComponent);
